import { createContext } from "react";
import type { ReactNode } from "react";

export interface BreadcrumbContextValue {
  overrides: Record<string, string>;
  setOverrides: (overrides: Record<string, string>) => void;
  contentOverrides: Record<string, ReactNode>;
  setContentOverrides: (contentOverrides: Record<string, ReactNode>) => void;
}

export const BreadcrumbContext = createContext<BreadcrumbContextValue>({
  overrides: {},
  setOverrides: () => {},
  contentOverrides: {},
  setContentOverrides: () => {},
});
